angular.module('ikeweb.map').value('CaptureMap',
    function CaptureMap(ikemap, center, captures) {

        function addCapture(capture) {
            var location = capture.getTargetLocation();
            if (location == null || !capture.hasPosition()) {
                return;
            }

            ikemap.addMarker(location, capture.getId());
        }

        function loadCapturesAndSetCenter() {
            captures.forEach(addCapture);

            if (center && center.location && center.zoom) {
                ikemap.setCenter(center.location, center.zoom);
            } else {
                ikemap.zoomToAllMarkers();
            }
        }

        this.getZoom = ikemap.getZoom;
        this.setZoom = ikemap.setZoom;
        this.zoomIn = ikemap.zoomIn;
        this.zoomOut = ikemap.zoomOut;
        this.zoomToAllMarkers = ikemap.zoomToAllMarkers;

        loadCapturesAndSetCenter();
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/map/capture/capture.map.js
// module id = 590
// module chunks = 0